import {Country} from "@/model/entity/country/country"
import {Type} from "class-transformer"

export class ColReqAddress {
  name?: string
  name2?: string
  @Type(() => Country)
  country?: Country
  postalCode?: string
  city?: string
  street?: string
  houseNumber?: string
  phone?: string
  email?: string
  depot?: string

  constructor(
    name?: string,
    name2?: string,
    country?: Country,
    postalCode?: string,
    city?: string,
    street?: string,
    houseNumber?: string,
    phone?: string,
    email?: string,
    depot?: string
  ) {
    this.name = name
    this.name2 = name2
    this.country = country
    this.postalCode = postalCode
    this.city = city
    this.street = street
    this.houseNumber = houseNumber
    this.phone = phone
    this.email = email
    this.depot = depot
  }
}
